var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nopower==true)?_c('div',{staticClass:"nopower"},[_c('img',{attrs:{"src":require("../assets/images/icon-no-auth.png"),"alt":""}}),_c('p',{staticClass:"no-auth-text"},[_vm._v("您暂时无法访问系统")]),_c('p',{staticClass:"no-auth-text-span"},[_vm._v("如需访问，请提交账号开通流程，如已提交流程，请联系IT客服处理")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }